import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8c38xgktp7: FaireBrandEntity = {
  token: "b_8c38xgktp7",
  type: "brand",
  name: "NAT + NOOR",
  avatarUrl:
    "https://cdn.faire.com/fastly/3b0fe0b25c071bcd65259f1627b7df2756a09f99147b3b6fb2c34fc4d6ee52ff.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3d18af5619a7b5a1c09d259790064c91e8558c56136357d020324c17b2b1e727.png",
  logoUrl:
    "https://cdn.faire.com/fastly/3b0fe0b25c071bcd65259f1627b7df2756a09f99147b3b6fb2c34fc4d6ee52ff.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3d18af5619a7b5a1c09d259790064c91e8558c56136357d020324c17b2b1e727.png",
  location: "Pleasant Grove, UT, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 699,
  isTopShop: true,
  isInsider: true,
  description:
    "We believe beauty is essential. \nCreativity nourishes the soul. \nStillness grounds us. \n\nIn a noisy world we are bringing light (Noor) \nthrough beauty, creativity, and stillness. \n\nWe create with beauty & functionality in mind. \nWe are concise yet playful. \n\nNoor means light in Arabic.\nThis word encompasses what we create and spread.\n\nNatalia, the founder and CEO has a background in the fine arts.\nShe has an obsession with color chemistry and immaculate design.\nHer passion is to elevate the everyday and breathe beauty into the small things.\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:31.968Z",
    importedBy: "entity-db-cli",
  },
};
